import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { shareService } from '../services/shareService';
import type { UpdateShareDto } from '../types';

export function useUpdateShare() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('shares');

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateShareDto }) =>
      shareService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shares'] });
    },
    onError: () => {
      toast.danger({ title: t('toasts.updateError') });
    },
  });
}
